export default __webpack_public_path__ + "static/media/Dark-circleCorrect.744f9940.svg";